/* eslint-disable react/no-danger */
/* eslint-disable tailwindcss/no-unnecessary-arbitrary-value */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { useState } from 'react';
import { Icon } from '../components-internal/Icon';
import { getTabTarget } from '../helpers/tabTarget';
import { pushDataLayer } from '../pushDataLayer';
import { ComponentHeaderWithTabs } from '$/(cms)/_modules/cmsService/types';
import Button from '$/components/Button';
import { FeLink } from '$/components/FeLink';
import ArrowRightAlt from '$/components/icons/ArrowRightAlt';
import { useClientContext } from '$/modules/context/client';

// import './HeaderWithTabs.css';

export const HeaderWithTabs: React.FC<ComponentHeaderWithTabs> = (props) => {
  const { title, over_title } = props;
  const { brand } = useClientContext();
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [isTabVisible, setTabIsVisible] = useState(true);

  if (!props.tabs || !props.tabs.length) return null;

  const tabs = props.tabs.filter((t) => !!t);

  const currentTab = tabs[currentTabIndex];

  const changeTab = (index: number) => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'tab',
      component_title: `Vertical Tab_${tabs?.[index]?.nameReq}`,
      action: 'click',
      index: index,
    });

    if (index === currentTabIndex) return;

    setTabIsVisible(false);
    setTimeout(() => {
      setCurrentTabIndex(index);
      setTabIsVisible(true);
    }, 200);
  };

  const ctaClick = (
    tabText: string,
    buttonText: string | undefined,
    index: number,
  ) => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'cta-button',
      component_title: `Vertical Tab/${tabText}_${buttonText}`,
      action: 'click',
      index: index,
    });
  };

  return (
    <div className="headerWithTabs">
      <div
        className={`homeTabsImg ${brand === 'moneyhero' ? 'moneyheroHomeTabsImg' : ''}`}
      >
        <div>
          <div className="relative mx-auto max-w-[1536px] px-4 py-8 pb-16 sm:px-6 md:min-h-[234px] md:p-10 md:px-8 md:pb-12 lg:px-10 lg:py-12 lg:pb-14">
            {over_title && (
              <h3 className="mb-2 font-semibold text-text/on-dark-2 text-font-size/sm leading-line-height/sm sm:text-font-size/md sm:leading-line-height/md md:mb-4 md:text-font-size/xl md:leading-line-height/xl">
                {over_title}
              </h3>
            )}
            <h1 className="mb-6 font-bold text-white text-font-size/4xl leading-line-height/4xl sm:text-font-size/4xl sm:leading-line-height/4xl md:mb-8 md:text-font-size/6xl md:leading-line-height/6xl">
              {title}
            </h1>

            <div
              className={`no-scrollbar absolute left-0 mr-2 flex max-w-full overflow-x-scroll px-4 pb-4 sm:px-6 md:px-10  lg:px-10 ${tabs.length < 10 ? 'lg:overflow-x-hidden' : ''}`}
            >
              <div className="relative z-1 flex rounded-lg drop-shadow-lg bg-white">
                {tabs.map((tab, index) => (
                  <FeLink
                    key={tab.id}
                    className={classNames(
                      'tab-click z-50 flex min-h-[88px] !min-w-[115px] flex-col break-words border-r border-gray-300 font-semibold bg-white text-gray-900',
                      'first:rounded-l-lg last:rounded-lg last:rounded-l-none last:border-0',
                      'sm:text-font-size/lg sm:leading-line-height/lg',
                      'h-[112px] p-spacing/padding/x-sm text-font-size/md leading-line-height/lg sm:w-[116px]',
                      'md:!h-[120px] md:!w-[136px]  md:text-font-size/lg md:leading-line-height/lg-plus',
                      'lg:!h-[136px] lg:!w-[136px]  lg:text-font-size/lg-plus lg:leading-line-height/lg',
                      'xl:!h-[136px] xl:!w-[152px]',
                      {
                        '!bg-fill/primary-light text-primary-dark':
                          currentTabIndex === index,
                      },
                    )}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      changeTab(index);
                    }}
                  >
                    {!!tab.icon && (
                      <i
                        className={`overrideIcon mb-2 size-[40px] rounded-full sm:mb-3 md:size-[48px] ${currentTabIndex === index ? '!bg-white !text-primary' : 'bg-gray-200 text-gray-700'}`}
                      >
                        <Icon icon={tab.icon} />
                      </i>
                    )}
                    <span className="alpha-button-1">{tab.nameReq}</span>
                  </FeLink>
                ))}
              </div>
            </div>
          </div>

          <div className="homeTabsGradient relative z-0 bg-white">
            <div className="mx-auto max-w-[1536px] px-4 py-8 !pt-16 sm:px-6 sm:!pt-20 md:p-10 md:px-8 md:!pt-28 lg:px-10 lg:py-12">
              <Transition
                key={currentTabIndex}
                show={isTabVisible}
                as="div"
                enter="transition-opacity duration-200 ease-in-out"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-200 ease-in-out"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <h3 className="mb-2 font-bold text-gray-900 text-font-size/2xl leading-line-height/2xl sm:text-font-size/2xl sm:leading-line-height/3xl md:mb-4 md:text-font-size/4xl md:leading-line-height/4xl">
                  {currentTab.headline}
                </h3>
                {!!currentTab.description && (
                  <div
                    className="mb-8 font-medium text-gray-800 text-font-size/md leading-line-height/md sm:text-font-size/md sm:leading-line-height/lg md:text-font-size/xl md:leading-line-height/xl"
                    dangerouslySetInnerHTML={{
                      __html: currentTab.description,
                    }}
                  />
                )}
                {currentTab.p_cta_label && currentTab.p_cta_url && (
                  <FeLink
                    href={currentTab.p_cta_url}
                    target={getTabTarget(currentTab.p_cta_target)}
                    title={currentTab.p_cta_label}
                  >
                    <Button
                      onClick={() =>
                        ctaClick(
                          currentTab.nameReq,
                          currentTab.p_cta_label ?? undefined,
                          currentTabIndex,
                        )
                      }
                      styleType="primary"
                      variant="filled"
                      endIcon={<ArrowRightAlt />}
                      className="mb-2 w-full md:max-w-[330px] lg:mb-4 lg:max-w-[350px] xl:max-w-[400px]"
                    >
                      {currentTab.p_cta_label}
                    </Button>
                  </FeLink>
                )}
                {currentTab.s_cta_label && currentTab.s_cta_url && (
                  <FeLink
                    href={currentTab.s_cta_url}
                    target={getTabTarget(currentTab.s_cta_target)}
                    title={currentTab.s_cta_label}
                  >
                    <Button
                      onClick={() =>
                        ctaClick(
                          currentTab.nameReq,
                          currentTab.s_cta_label ?? undefined,
                          currentTabIndex,
                        )
                      }
                      styleType="primary"
                      variant="outline"
                      className="w-full md:max-w-[330px] lg:max-w-[350px] xl:max-w-[400px]"
                    >
                      {currentTab.s_cta_label}
                    </Button>
                  </FeLink>
                )}
              </Transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
